exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.icon[data-v-9fac3950]{font-size:14px\n}\n", "", {"version":3,"sources":["/app/frontend/src/screens/analise/components/AppUtilizarButtons.vue"],"names":[],"mappings":";AAsCA,uBACE,cAAe;CAChB","file":"AppUtilizarButtons.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.icon {\n  font-size: 14px;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9fac3950","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/analise/components/AppUtilizarButtons.vue
// module id = LVM/
// module chunks = 11